import DarkFrameworkImages from '@vfgroup-oneplatform/framework/Themes/Modes/Dark/Images'

import { Image } from 'react-native'

import images from '../../Images'

const Images = {
  ...DarkFrameworkImages,
  ...images,

  phone: Image.resolveAssetSource(require('../../../Images/Icons/darkMode/phone.png')),
  airplane: Image.resolveAssetSource(require('../../../Images/Icons/darkMode/airplane.png')),
  smsTextWhite: Image.resolveAssetSource(require('../../../Images/Icons/darkMode/sms_text.png')),

  smsText: images.smsTextWhite,
  landline: images.landlineWhite,
  dataSharing: images.dataSharingWhite,
  offerDefaultIcon: images.offerDefaultIconWhite,
  idCard: images.idCardWhite,
  address: images.addressWhite,
}

export default Images